import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['success', 'failure', 'greeting', 'select'];

    connect() {
        this.selectTarget.addEventListener('change', this.handleCountryChange.bind(this));
    }

    handleCountryChange() {
        let option = this.selectTarget.options[this.selectTarget.selectedIndex];

        this.successTarget.classList.toggle('hidden', option.dataset.customProperties === 'true' ? false : true);
        this.failureTarget.classList.toggle('hidden', option.dataset.customProperties !== 'true' ? false : true);

        this.greetingTarget.innerText = this.getGreetingText(option.value);
    }

    getGreetingText(countryCode) {
        const greetings = {

            A1: 'Hello',
            A2: 'Hello',
            AD: 'Hola',
            AE: 'Marhaba',
            AF: 'Senga yai',
            AG: 'Hello',
            AI: 'Hello',
            AL: 'Tungjatjeta',
            AM: 'Barev',
            AN: 'Kon ta bai',
            AO: 'Olá',
            AP: 'Hello',
            AQ: 'Hello',
            AR: 'Hola',
            AS: 'Hello',
            AT: 'Hallo',
            AU: 'Hello',
            AW: 'Kon ta bai',
            AX: 'Hello',
            AZ: 'Salam',
            BA: 'Zdravo',
            BB: 'Hello',
            BD: 'Namaskar',
            BE: 'Hallo',
            BF: 'Bonjour',
            BG: 'Zdravei',
            BH: 'Marhaba',
            BI: 'Bonjour',
            BJ: 'Bonjour',
            BM: 'Hello',
            BN: 'Selamat',
            BO: 'Hola',
            BR: 'Olá',
            BS: 'Hello',
            BT: 'Kuzu zangpo',
            BV: 'Hello',
            BW: 'Dumela',
            BY: 'Вітаю',
            BZ: 'Hello',
            CA: 'Hello',
            CD: 'Bonjour',
            CF: 'Bonjour',
            CG: 'Bonjour',
            CH: 'Hallo',
            CI: 'Bonjour',
            CK: 'Kia orana',
            CL: 'Hola',
            CM: 'Hello',
            CN: '你好',
            CO: 'Hola',
            CR: 'Hola',
            CU: 'Hola',
            CV: 'Olá',
            CY: 'Γεια σου',
            CZ: 'Dobrý den',
            DE: 'Hallo',
            DJ: 'Marhaba',
            DK: 'Hej',
            DM: 'Hello',
            DO: 'Hola',
            DZ: 'Marhaba',
            EC: 'Hola',
            EE: 'Tervist',
            EG: 'Marhaba',
            ER: 'Marhaba',
            ES: 'Hola',
            ET: 'Teanastëllën',
            EU: 'Hello',
            FI: 'Moi',
            FJ: 'Hello',
            FK: 'Hello',
            FM: 'Hello',
            FO: 'Hallo',
            FR: 'Bonjour',
            GA: 'Bonjour',
            GB: 'Hello',
            GD: 'Hello',
            GE: 'Gamardjobat',
            GF: 'Bonjour',
            GG: 'Hello',
            GH: 'Hello',
            GI: 'Hello',
            GL: 'Aluu',
            GM: 'Hello',
            GN: 'Bonjour',
            GP: 'Hello',
            GQ: 'Hola',
            GR: 'Γεια σουσύ',
            GS: 'Hello',
            GT: 'Hola',
            GU: 'Håfa adai',
            GW: 'Olá',
            GY: 'Hello',
            HK: '你好',
            HM: 'Hello',
            HN: 'Hola',
            HR: 'Bok',
            HT: 'Bonjou',
            HU: 'Szia',
            ID: 'Halo',
            IE: 'Hello',
            IL: 'Shalom',
            IM: 'Hello',
            IN: 'Namaste',
            IO: 'Hello',
            IQ: 'Marhaba',
            IR: 'Salam',
            IS: 'Hæ',
            IT: 'Ciao',
            JE: 'Hello',
            JM: 'Hello',
            JO: 'Marhaba',
            JP: 'こんにちは',
            KE: 'Jambo',
            KG: 'Salam',
            KH: 'សួស្តី',
            KI: 'Mauri',
            KM: 'Bariza',
            KN: 'Hello',
            KP: '안녕하세요',
            KR: '안녕하세요',
            KW: 'Marhaba',
            KY: 'Hello',
            KZ: 'Сәлем',
            LA: 'Sabaidee',
            LB: 'Marhaba',
            LC: 'Hello',
            LI: 'Hallo',
            LK: 'හෙලෝ',
            LR: 'Hello',
            LS: 'Lumela',
            LT: 'Labas',
            LU: 'Moien',
            LV: 'Sveiki',
            LY: 'Marhaba',
            MA: 'Marhaba',
            MC: 'Bonjour',
            MD: 'Salut',
            ME: 'Zdravo',
            MF: 'Hello',
            MG: 'Manao ahoana',
            MH: 'Yokwe',
            MK: 'Здраво',
            ML: 'Bonjour',
            MM: 'မင်္ဂလာပါ',
            MN: 'Сайн байна уу',
            MO: '你好',
            MP: 'Hello',
            MQ: 'Hello',
            MR: 'Marhaba',
            MS: 'Hello',
            MT: 'Bonġu',
            MU: 'Bonzour',
            MV: 'މަޝްބޫލުވެއްޖޭގެން',
            MW: 'Muli bwanji',
            MX: 'Hola',
            MY: 'Hello',
            MZ: 'Olá',
            NA: 'Hallo',
            NC: 'Bonjour',
            NE: 'Bonjour',
            NF: 'Hello',
            NG: 'Hello',
            NI: 'Hola',
            NL: 'Hallo',
            NO: 'Hei',
            NP: 'नमस्ते',
            NR: 'Hello',
            NU: 'Fakaalofa atu',
            NZ: 'Kia ora',
            OM: 'Marhaba',
            PA: 'Hola',
            PE: 'Hola',
            PF: 'Bonjour',
            PG: 'Hello',
            PH: 'Hello',
            PK: 'ہیلو',
            PL: 'Cześć',
            PM: 'Hello',
            PN: 'Hello',
            PR: 'Hola',
            PS: 'Marhaba',
            PT: 'Olá',
            PW: 'Alii',
            PY: 'Hola',
            QA: 'Marhaba',
            RE: 'Hello',
            RO: 'Bună',
            RS: 'Здраво',
            RU: 'Привет',
            RW: 'Muraho',
            SA: 'Marhaba',
            SB: 'Hello',
            SC: 'Hello',
            SD: 'Marhaba',
            SE: 'Hej',
            SG: 'Hello',
            SH: 'Hello',
            SI: 'Zdravo',
            SJ: 'Hei',
            SK: 'Ahoj',
            SL: 'Hello',
            SM: 'Ciao',
            SN: 'Bonjour',
            SO: 'Iska warran',
            SR: 'Hello',
            SS: 'Marhaba',
            ST: 'Olá',
            SV: 'Hola',
            SX: 'Hello',
            SY: 'Marhaba',
            SZ: 'Sawubona',
            TC: 'Hello',
            TD: 'Salam',
            TF: 'Bonjour',
            TG: 'Bonjour',
            TH: 'สวัสดีค่ะ',
            TJ: 'Салом',
            TK: 'Talofa',
            TL: 'Ola',
            TM: 'Salam',
            TN: 'Marhaba',
            TO: 'Mālō e lelei',
            TR: 'Merhaba',
            TT: 'Hello',
            TV: 'Hello',
            TW: '你好',
            TZ: 'Hujambo',
            UA: 'Привіт',
            UG: 'Hello',
            UM: 'Hello',
            US: 'Hello',
            UY: 'Hola',
            UZ: 'Salom',
            VA: 'Ciao',
            VC: 'Hello',
            VE: 'Hola',
            VG: 'Hello',
            VI: 'Hello',
            VN: 'Xin chào',
            VU: 'Halo',
            WF: 'Hello',
            WS: 'Talofa',
            YE: 'Marhaba',
            YT: 'Hello',
            ZA: 'Hello',
            ZM: 'Hello',
            ZW: 'Hello',
            RD: 'Bonjour'
        };
        return greetings[countryCode] || 'Hello';
    }
}
